export const TOGGLE_SIDE_PANEL = 'TOGGLE_SIDE_PANEL';
export const SET_PANEL_PARAMS = 'SET_PANEL_PARAMS';
export const CLOSE_SIDE_PANEL = 'CLOSE_SIDE_PANEL';
export const SET_MEDIA_QUERIES = 'SET_MEDIA_QUERIES';
